import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, MapPin } from 'lucide-react';

const POSTER_FALLBACK = 'https://media.base44.com/images/public/6958216a4cd06732f9f425e2/1b356f377_generated_ae06e16d.jpg';

/** Formats the Square event start date in the event's own time zone. */
function formatEventDate(startAt, timeZone, opts) {
  if (!startAt) return null;
  return new Date(startAt).toLocaleDateString('en-GB', { timeZone: timeZone || 'Europe/London', ...opts });
}

/** A single featured event as a paper invitation card. */
export default function EventItemCard({ item }) {
  const eventDate = formatEventDate(item.event_start_at, item.event_time_zone, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  const day = formatEventDate(item.event_start_at, item.event_time_zone, { day: 'numeric' });
  const times = item.variation_names || [];

  return (
    <div className="inv-card">
      <div className="inv-body">
        <h3 className="inv-title">{item.name}</h3>
        <div className="inv-meta inv-sans">
          {eventDate && <p><Calendar strokeWidth={2} />{eventDate}</p>}
          {times.length > 0 &&
            <p><Clock strokeWidth={2} /><span className="inv-chips">{times.map((t) => <span key={t} className="inv-chip">{t}</span>)}</span></p>
          }
          {item.event_location_name && <p><MapPin strokeWidth={2} />{item.event_location_name}</p>}
        </div>
        {item.description && <p className="inv-desc inv-sans">{item.description}</p>}
        <div className="inv-row">
          {item.price != null && <span className="inv-price">£{Number(item.price).toFixed(2)}</span>}
          <Link to={`/Events/${item.id}`} className="inv-btn inv-sans">Book tickets</Link>
        </div>
      </div>
      <div className="inv-poster"><img src={item.image_url || POSTER_FALLBACK} alt={item.name} loading="lazy" /></div>
    </div>
  );
}